module.exports = __webpack_public_path__ + "static/JohnTheHuman-5e71105ab200d5fe0e6fdcc9b0f248fd.png";